import { toError } from './parsers/error';
import { toSitesInfo, toUser, toManagerInfo } from './mappers/user';
export function initUser(settings, http) {
  /**
   * @summary Returns user
   * @memberof source.user
   * @param {String} userId
   * @param {Object} [options]
   * @returns {Promise}
   * @fulfill {User}
   * @reject {Error}
   */
  function getRequest(userId, options) {
    if (options === void 0) {
      options = {};
    }
    const queryParams = {};
    if (settings.namespace) {
      queryParams.ns = settings.namespace;
    }
    return http.get(`${settings.apiUrl}/site/media/users/${userId}/info`, queryParams, {
      headers: options.headers || {}
    }).then(res => ({
      ...res,
      data: toUser(res.data)
    })).catch(toError);
  }
  function getSitesInfo(options) {
    if (options === void 0) {
      options = {};
    }
    const queryParams = {};
    return http.get(`${settings.apiUrl}/site/media/manager/user/info`, queryParams, {
      headers: options.headers || {}
    }).then(res => ({
      ...res,
      data: toSitesInfo(res.data)
    })).catch(toError);
  }

  // @deprecated
  function getManagerInfo(options) {
    if (options === void 0) {
      options = {};
    }
    const queryParams = {};
    return http.get(`${settings.apiUrl}/go/site/media/manager/info`, queryParams, {
      headers: options.headers || {}
    }).then(res => ({
      ...res,
      data: toManagerInfo(res.data)
    })).catch(toError);
  }
  return {
    get: getRequest,
    getSitesInfo,
    getManagerInfo
  };
}